import { z } from 'zod'
import { oc } from '@orpc/contract'
import { authLoginSuccessSchema, nativeClientFields } from './auth-login.contract'

/**
 * POST /v2/auth/profile-select (PD-1512) — resolves a membershipSelect challenge from
 * login. Returns the MFA challenge for the chosen profile, or a session directly when
 * the device is trusted.
 */
export const authProfileSelect = oc
  .route({ method: 'POST', path: '/v2/auth/profile-select' })
  .input(
    z.object({
      challengeId: z.string().min(1),
      membershipId: z.string().min(1),
      ...nativeClientFields,
      /** Native's body twin of the trust cookie — enables the trusted-device short-circuit. */
      trustToken: z.string().optional(),
    }),
  )
  .output(
    z.discriminatedUnion('state', [
      z.object({
        state: z.literal('mfa'),
        challengeId: z.string(),
        methods: z.object({ phone: z.boolean(), email: z.boolean() }),
        maskedPhone: z.string().optional(),
        maskedEmail: z.string().optional(),
      }),
      authLoginSuccessSchema,
    ]),
  )
